export default __webpack_public_path__ + "8db2ff5375b2846285bbb5e99eee763b.png";